/* eslint-disable no-unreachable */
import gsap from 'gsap';
import rgbHex from 'rgb-hex';
import Sniffer from 'sniffer';

import SplitText from 'gsap/SplitText';
import DrawSVGPlugin from 'gsap/DrawSVGPlugin';

import {
  math,
  webgl,
  app,
  slider,
} from '@/utils/store';

import router from '@/router/index';
import notdata from './data';

const data = notdata[app.language];

gsap.registerPlugin(DrawSVGPlugin);

class Slider {
  constructor() {
    this.pointer = {
      dot: document.querySelector('.pointer-dot'),
      circle: document.querySelector('.pointer-circle'),
    };

    this.indicator = {
      el: document.querySelector('.slider-indicator svg'),
      outer: document.querySelector('.slider-indicator .outer'),
    };

    this.slider = {
      el: document.getElementById('a-slider'),
      s: document.querySelector('.slider-scroll'),
      a: document.querySelector('.slider-adjacent'),
      h1: document.querySelectorAll('.slider-heading'),
      p: document.querySelectorAll('.slider-description'),
    };

    this.current = [
      this.c = {
        h1: undefined,
        p: undefined,
      },
      this.n = {
        h1: undefined,
        p: undefined,
      },
    ];

    this.next = [
      this.c = {
        h1: undefined,
      },
      this.n = {
        h1: undefined,
      },
    ];

    this.color = {
      next: undefined,
      prev: undefined,
      current: undefined,
    };

    this.mouse = {
      f: true,
      t: window.innerHeight / 2,
      p: window.innerHeight / 2,
    };

    this.scroll = {
      last: 0,
      ease: 0.1,
    };

    this.animating = false;
  }

  init() {
    this.events();
  }

  destroy = () => {
    gsap.ticker.remove(this.render);
  }

  events() {
    gsap.ticker.add(this.render);

    this.slider.a.addEventListener('click', this.nextSlide);
    this.indicator.el.addEventListener('click', this.nextSlide);
    this.slider.s.addEventListener('click', this.discover);

    if (Sniffer.isDevice) return;

    window.addEventListener('mousemove', this.track);

    this.slider.el.addEventListener('mouseenter', () => {
      this.mouse.f = true;
    });

    this.slider.el.addEventListener('mouseleave', () => {
      this.mouse.f = false;
    });
  }

  discover = () => {
    app.scroll.data.current = -(window.innerHeight + window.innerWidth * 0.04688);
  }

  track = (e) => {
    if (this.mouse.f === false) {
      this.mouse.t = window.innerHeight / 2;
    } else if (e.clientY <= window.innerWidth * 0.15) {
      this.mouse.t = window.innerWidth * 0.15;
    } else {
      this.mouse.t = e.clientY;
    }
  }

  wrap = (e) => {
    e.style.display = '';
    e.style.position = '';
    const d = document.createElement('div');
    d.classList.add('cube');
    e.parentNode.insertBefore(d, e);
    d.appendChild(e);
  }

  load = () => {
    document.body.classList.remove('is-loading');
    router.push(`/${app.language}/${data.slides[slider.next].a}`);
    app.animating = false;
  }

  prevSlide = () => {
    // active
    this.slider.h1[1].innerHTML = data.slides[0].h1;
    this.slider.p[1].innerHTML = data.slides[0].p;

    this.current[1].h1 = new SplitText(this.slider.h1[1], { type: 'chars' });
    this.current[1].p = new SplitText(this.slider.p[1], { type: 'lines' });

    [...this.current[1].h1.chars].forEach((e) => {
      this.wrap(e);
    });

    gsap.set(this.current[1].p.lines, {
      y: 50,
      opacity: 0,
    });

    // adjacent
    this.slider.h1[3].innerHTML = data.slides[1].h1;

    this.next[1].h1 = new SplitText(this.slider.h1[3], { type: 'chars' });

    [...this.next[1].h1.chars].forEach((e) => {
      this.wrap(e);
    });

    // webgl
    slider.next = 0;
    slider.prev = 0;

    this.color.current = slider.current;
    this.color.next = slider.next;

    // animate
    setTimeout(() => {
      this.nextSlide();
    });
  }

  setSlide = () => {
    this.animating = false;

    this.slider.el.classList.remove('animate');

    // restet
    slider.prev = undefined;

    // active
    if (slider.current === 0) {
      this.slider.h1[0].innerHTML = data.slides[0].h1;
      this.slider.p[0].innerHTML = data.slides[0].p;

      this.slider.h1[1].innerHTML = data.slides[1].h1;
      this.slider.p[1].innerHTML = data.slides[1].p;
    }

    if (slider.current === 1) {
      this.slider.h1[0].innerHTML = data.slides[1].h1;
      this.slider.p[0].innerHTML = data.slides[1].p;

      this.slider.h1[1].innerHTML = data.slides[2].h1;
      this.slider.p[1].innerHTML = data.slides[2].p;
    }

    if (slider.current === 2) {
      this.slider.h1[0].innerHTML = data.slides[2].h1;
      this.slider.p[0].innerHTML = data.slides[2].p;

      this.slider.h1[1].innerHTML = data.slides[0].h1;
      this.slider.p[1].innerHTML = data.slides[0].p;
    }

    this.current[0].h1 = new SplitText(this.slider.h1[0], { type: 'chars' });
    this.current[0].p = new SplitText(this.slider.p[0], { type: 'lines' });

    this.current[1].h1 = new SplitText(this.slider.h1[1], { type: 'chars' });
    this.current[1].p = new SplitText(this.slider.p[1], { type: 'lines' });

    [...this.current[0].h1.chars].forEach((e) => {
      this.wrap(e);
    });

    [...this.current[1].h1.chars].forEach((e) => {
      this.wrap(e);
    });

    gsap.set(this.current[1].p.lines, {
      y: 50,
      opacity: 0,
    });

    // adjacent
    if (slider.current === 0) {
      this.slider.h1[2].innerHTML = data.slides[1].h1;
      this.slider.h1[3].innerHTML = data.slides[2].h1;
    }

    if (slider.current === 1) {
      this.slider.h1[2].innerHTML = data.slides[2].h1;
      this.slider.h1[3].innerHTML = data.slides[0].h1;
    }

    if (slider.current === 2) {
      this.slider.h1[2].innerHTML = data.slides[0].h1;
      this.slider.h1[3].innerHTML = data.slides[1].h1;
    }

    this.next[0].h1 = new SplitText(this.slider.h1[2], { type: 'chars' });
    this.next[1].h1 = new SplitText(this.slider.h1[3], { type: 'chars' });

    [...this.next[0].h1.chars].forEach((e) => {
      this.wrap(e);
    });

    [...this.next[1].h1.chars].forEach((e) => {
      this.wrap(e);
    });

    // indicator
    gsap.set(this.indicator.outer, {
      rotation: 180,
      transformOrigin: 'center center',
      drawSVG: `${(100 / 3) * (slider.current + 1)}% 0%`,
    });

    // webgl
    this.color.current = slider.current;
    this.color.next = slider.next;

    if (webgl.loaded === true) {
      webgl.app.objColor = data.slides[slider.current].c;
      webgl.app.animate = slider.current;
    }
  }

  nextSlide = () => {
    if (this.animating === true) return;

    document.body.classList.add('is-loading');

    // scroll
    app.scroll.disable();
    app.scroll.data.current = 0;

    // animate
    this.animating = true;
    this.slider.el.classList.add('animate');

    // current
    gsap.to(this.current[0].p.lines, {
      y: -50,
      opacity: 0,
      duration: 1,
      stagger: 0.1,
      ease: 'expo.in',
    });

    // next
    gsap.to(this.current[1].p.lines, {
      y: 0,
      delay: 1,
      opacity: 1,
      duration: 1,
      stagger: 0.1,
      ease: 'expo.out',
    });

    // webgl
    if (slider.next === 0) {
      webgl.animate = 3;
    } else {
      webgl.animate = slider.next;
    }

    if (slider.prev === 0) {
      webgl.animate = 0;
    }

    gsap.to(webgl.app, {
      duration: 3,
      ease: 'expo.inOut',
      animate: webgl.animate,
    });

    const from = {
      value: gsap.utils.splitColor(`${data.slides[this.color.current].h}`),
    };

    const to = {
      value: gsap.utils.splitColor(`${data.slides[this.color.next].h}`),
    };

    gsap.to(from, {
      duration: 3,
      value: to.value,
      ease: 'expo.inOut',
      onComplete: this.load,
      onUpdate: () => {
        const rgb = from.value.toString().split(',');
        const hex = rgbHex(parseInt(rgb[0], 10), parseInt(rgb[1], 10), parseInt(rgb[2], 10));
        webgl.app.objColor = `0x${hex}`;
      },
    });

    // indicator
    gsap.to(this.indicator.outer, {
      rotation: 180,
      duration: 1.5,
      ease: 'expo.inOut',
      transformOrigin: 'center center',
      drawSVG: `${(100 / 3) * (slider.next + 1)}% 0%`,
    });
  }

  render = () => {
    if (app.loading === true) {
      this.scroll.last = 0;
      app.scroll.data.current = 0;
      return;
    }

    if (Sniffer.isPhone && app.scroll.data.current < -window.innerHeight) {
      document.body.classList.add('is-vp');
    } else if (document.body.classList.contains('is-vp')) {
      document.body.classList.remove('is-vp');
    }

    if (app.contact === true || app.navigation === true) return;

    this.scroll.last = math.lerp(this.scroll.last, app.scroll.data.current, this.scroll.ease);

    if (webgl.loaded === true && webgl.pause === false) {
      if (Sniffer.isPhone) {
        webgl.app.offsetY = -(this.scroll.last / 1.5) + window.innerHeight * 0.15;
      } else {
        webgl.app.offsetY = -this.scroll.last / 1.5;
      }
    }

    if (this.scroll.last < -window.innerHeight * 2) {
      if (webgl.pause === false) {
        webgl.pause = true;
        webgl.app.pause();
      }
    }

    if (this.scroll.last > -window.innerHeight * 2 && webgl.pause === true && app.navigation === false) {
      webgl.pause = false;
      webgl.app.play();
    }

    if (Sniffer.isDevice) return;

    const b = this.slider.el.getBoundingClientRect().top;

    if (this.mouse.f === true) {
      this.mouse.p = math.lerp(this.mouse.p, this.mouse.t - b, 0.05);
    } else {
      this.mouse.p = math.lerp(this.mouse.p, this.mouse.t, 0.05);
    }

    this.indicator.el.style.transform = `translate3d(0px, ${this.mouse.p}px, 0px)`;
  }
}

export default Slider;
